import React from "react"
import { Spinner } from 'reactstrap';

export const PaymentSpinner = () => {
    return (
        <div className='spinner-container'>
            <Spinner size="lg" color="dark" />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Payment/PaymentSpinner.js